import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';

import { LinxStatus } from '@shared/constants/app-constants';
import { reportApiFailure } from '@shared/services/sentry/api-failure-reporter';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err) => {
        // KOR-15194: the failures only the browser sees go to Sentry before they become an error page. Reporting never
        // changes what the caller receives below.
        if (err instanceof HttpErrorResponse) {
          reportApiFailure({
            status: err.status,
            method: request.method,
            url: request.urlWithParams,
            body: err.error,
            route: this.router.url,
          });
        }

        if (err.error === LinxStatus.SYSTEM_MAINTENANCE) {
          return throwError(() => LinxStatus.SYSTEM_MAINTENANCE);
        }
        if ([HttpStatusCode.InternalServerError, HttpStatusCode.ServiceUnavailable].includes(err.status)) {
          return throwError(() => LinxStatus.ERROR);
        }
        if (err?.error?.result) {
          return throwError(() => err.error.result);
        }

        // KOR names the reason for a rejection in `errorCode`, and some are not failures at all -
        // `status-invalid` on a step submit means the server already completed that step. Flattening
        // to the status number leaves a caller unable to tell those apart, so keep the whole
        // response when the body says why. Everything else still arrives as the status, which is
        // what callers matching on a number expect.
        if (err?.error?.errorCode) {
          return throwError(() => err);
        }

        return throwError(() => err.status);
      }),
    );
  }
}
